import React from 'react';

import styles from './MenuItem.module.scss';
import Icon from '../../UI/Icon/Icon';
import IconSuccess from '../../UI/Icon/IconSuccess';

function MenuItem({
  children,
  active,
  completed,
  disabled,
  icon,
  onClick = () => {},
  globalState,
}) {
  const { primary } = globalState.getColorScheme();

  const className = [styles.MenuItem];
  active && className.push(styles['MenuItem--active']);
  disabled && className.push(styles['MenuItem--disabled']);

  const style = active ? { borderLeftColor: primary } : {};

  return (
    <div
      className={className.join(' ')}
      style={style}
      onClick={!disabled ? onClick : () => {}}
    >
      <Icon icon={icon} className={styles.MenuItem__icon} />
      <span className={styles.MenuItem__label}>{children}</span>
      {completed ? (
        <IconSuccess
          className={styles.MenuItem__icon}
          testId="MenuItem__icon__success"
        />
      ) : (
        <Icon icon="circle" className={styles.MenuItem__icon} />
      )}
    </div>
  );
}

export default MenuItem;
